import { createListenerMiddleware } from "@reduxjs/toolkit";
import {
  collectionGroup,
  query,
  where,
  onSnapshot,
  Unsubscribe,
  collection,
} from "firebase/firestore";
import { db } from "../firebase/FirebaseCredential";
import { RootState } from "../store/store";
import { setSubscription, clearSubscription } from "./subscriptionSlice";

export const subscriptionListenerMiddleware = createListenerMiddleware();
let unsubscribeFunction: Unsubscribe | null = null;

subscriptionListenerMiddleware.startListening({
  predicate: (_, currentState) => {
    const state = currentState as RootState;
    return state.subscriptionData.active === null;
  },

  effect: async (_, listenerApi) => {
    try {
      const state = listenerApi.getState() as RootState;
      const companyId = state.session.company_id;
      if (!companyId) return;

      const benchsubscription = collection(db, "companyprofile", `${companyId}`, "benchsubscription");


      // 🔹 Listen to active benchsubscriptions
      const q = query( benchsubscription,
        where("status", "==", "Active")
      );

      unsubscribeFunction = onSnapshot(q, async (querySnapshot) => {
        const planIds = querySnapshot.docs.map((doc) => doc.data().plan_id);
        if (planIds.length === 0) {
          listenerApi.dispatch(
            setSubscription({ active: false, snapshot: [] })
          );
          return;
        }

        // 🔹 Fetch plan data and merge features
        const planQuery = query(
          collection(db, "systemsubscriptionplan"),
          where("plan_id", "in", planIds)
        );

        onSnapshot(planQuery, (planSnapshot) => {
          const mergedFeatures = planSnapshot.docs.flatMap((doc) => {
            const data = doc.data();
            const baseFeatures =
              data.base_features || data["base_features "] || [];
            return baseFeatures;
          });

          // 🔹 Build final subscription data
          const snapshot = querySnapshot.docs.map((doc) => {
            const data = doc.data();
            return {
              id: doc.id,
              company_id: data.company_id ?? "",
              status: data.status ?? "Inactive",
              plan_id: data.plan_id ?? "",
              plan_name: data.plan_name ?? "",
              allowed_staff_limit: data.allowed_staff_limit ?? 0,
              allowed_branch_limit: data.allowed_branch_limit ?? 0,
              remaining_staff_limit: data.remaining_staff_limit ?? 0,
              remaining_branch_limit: data.remaining_branch_limit ?? 0,
              features:[ ...mergedFeatures , ...data.enabled_features, ...(data.base_features || [])]
            };
          });

          listenerApi.dispatch(
            setSubscription({ active: !querySnapshot.empty, snapshot })
          );

          // console.log("✅ Merged subscription data:", snapshot);
        });
      });
    } catch (error) {
      console.error("Error subscribing to Firestore:", error);
    }
  },
});

// 🔹 Stop listening when `clearSubscription` is dispatched
subscriptionListenerMiddleware.startListening({
  actionCreator: clearSubscription,
  effect: async () => {
    if (unsubscribeFunction) {
      unsubscribeFunction();
      unsubscribeFunction = null;
    }
  },
});
